



import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "empty",
  components: {},
})
export default class empty extends Vue {
  async validate() {
    return true;
  }
}
